import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue"
import config from "../../config"
import { useI18n } from "vue-i18n"


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguagePicker',
  setup(__props, { expose: __expose }) {
  __expose();

const { availableLocales, locale } = useI18n()

const languages = ref(availableLocales)
const selected = ref(locale)

watch(locale, (newValue) => {
  selected.value = newValue
})

const changeLang = (lang: string) => {
  locale.value = lang
  selected.value = lang
}

const __returned__ = { availableLocales, locale, languages, selected, changeLang, ref, watch, get config() { return config }, get useI18n() { return useI18n } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})